module.exports = __webpack_public_path__ + "media/images/lb/339-59cefe993f078b3d0888193fc2dcf8ed.svg";